import { useEffect, useState } from 'react';

type InteractionType = 'keyboard' | 'mouse' | null;

export const useUserInteraction = () => {
  const [lastInteraction, setLastInteraction] = useState<InteractionType>(null);

  useEffect(() => {
    const handleKeyDown = () => {
      setLastInteraction('keyboard');
    };
    const handleMouseDown = () => {
      setLastInteraction('mouse');
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return { lastInteraction };
};
